import React from 'react'

function CustomerView ()  {
  return (
    <h1>Cliente</h1>
  )
}

export default CustomerView;
